class DZFilter{
    constructor(){

    }

    addFilter(filter, cat){
        console.log(cat)
        var cUrl = window.location.href
        var cUrlParts = cUrl.split('/')
        var currentFilters = cUrlParts[cUrlParts.length-1]
        console.log('FILTERS::',currentFilters)
        console.log('ADD FILTER::', filter)
        if(currentFilters == cat || currentFilters == ''){
            if(currentFilters == ''){
                cUrl+=filter
            }else{
                cUrl+='/'+filter
            }
            
            console.log('NEW LOCATION::', cUrl)
        }else{
            cUrl+='+'+filter
        }

        window.location.href = cUrl
        
    }

    removeFilter(filter, cat){
        var cUrl = window.location.href
        console.log(cUrl)
        var cUrlParts = cUrl.split('/')
        console.log(cUrlParts)
        var currentFilters = cUrlParts[cUrlParts.length-1]
        console.log(currentFilters)
        var arrCurrentFilters = currentFilters.split('+')
        console.log(arrCurrentFilters)
        var leftFilters = arrCurrentFilters.filter(f => f != filter)
        console.log(leftFilters)
        var newUrl = cUrl.split('the-intuition')[0]+cat+'/'+leftFilters.join('+')
        console.log('REDUCED FILTERS::',newUrl)

        window.location.href = newUrl
    }

    removeMainFilter(filters, cat){
        console.log(filters)
        window.location.href = window.location.href.split(cat)[0]+'the-intuition/'+filters

    }
}
var intuitionFilters = new DZFilter()